// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EiVjU","appear2":"Footer_appear2__umwy5"};